import { END_POINT } from "../constants/api.constants";
import {store} from "../store";

const {
  UPDATE_PROFILE,
  SAVE_ADDRESS,
  DELETE_ADDRESS,

} = END_POINT;

export const saveCustomerAPI = async (payload) => {
  return await fetch(UPDATE_PROFILE, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      token: store.getState().app.token,
    },
    body: JSON.stringify(payload),
  })
    .then((res) => res.json())
    .then((data) => {
      return {
        status: data.status,
        message: data.message,
        data: data.data,
      };
    })
    .catch((error) => {
      console.error('Error saving customer:', error);
      return {
        status: false,
        message: "Something went wrong while saving customer data.",
        error,
      };
    });
};

export const saveCustomerAddressAPI = async (payload) => {
  return await fetch (SAVE_ADDRESS, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      token: store.getState().app.token,
    },
    body: JSON.stringify(payload),
  })
    .then((res) => res.json())
    .then((data) => {
      return {
        status: data.status,
        message: data.message,
        data: data.data,
      };
    })
    .catch((error) => {
      console.error('Error saving customer address:', error);
      return {
        status: false,
        message: "Something went wrong while saving address.",
        error,
      };
    });
};

export const deleteCustomerAddressAPI = async (payload) => {
  return await fetch (DELETE_ADDRESS, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      token: store.getState().app.token,
    },
    body: JSON.stringify(payload),
  })
    .then((res) => res.json())
    .then((data) => {
      return {
        status: data.status,
        message: data.message,
        data: data.data,
      };
    })
    .catch((error) => {
      console.error('Error deleting customer address:', error);
      return {
        status: false,
        message: "Something went wrong while deleting address.",
        error,
      };
    });
};
